module.exports = __webpack_public_path__ + "img/bar.24b78e11.svg";